module.exports = __webpack_public_path__ + "img/官网-证书-实训.6d652120.png";